<template>
  <div>
    <Menu mode="horizontal" @on-select="onSelect" class="header">
      <router-link v-if="!showNavicon" to="/" class="header-logo">
        <img src="@/assets/images/icon.min.png" alt="ComTrial Express EDC"> <span>Express EDC</span>
      </router-link>
      <div class="header-middle-con">
        <div class="main-breadcrumb">
          <breadcrumb></breadcrumb>
        </div>
      </div>

      <div class="layout-nav">

        <Submenu name="system" v-if="isAuthed">
          <template slot="title">
            <Icon type="ios-cog" /> 系统设置
          </template>
          <Menu-item name="study">
            <Icon type="ios-list" /> 研究管理
          </Menu-item>
          <Menu-item name="list-roles">
            <Icon type="ios-person" /> 角色管理
          </Menu-item>
          <Menu-item name="list-auths">
            <Icon type="md-key" /> 权限体系
          </Menu-item>
        </Submenu>

        <Menu-item name="message">
          <Badge :count="this.$store.getters.messageNum" :overflow-count="99"  style="display: inline;">
            <Icon type="ios-notifications" size="18" class="message-badge"></Icon>
          </Badge>
        </Menu-item>
        <Submenu name="5" style="">
          <template slot="title">
            <Avatar style="background-color: #87d068" v-if="!this.$store.getters.getPortraitLink" alt="头像" class="head-portrait-mn">U</Avatar>
            <Avatar v-bind:src="this.$store.getters.getPortraitLink" v-if="this.$store.getters.getPortraitLink" alt="头像" class="head-portrait-mn" />
          </template>
          <Menu-item name="user">
            <router-link to="/user">账户设置</router-link>
          </Menu-item>
          <Menu-item name="logout">
            退出登录
          </Menu-item>
        </Submenu>
      </div>
    </Menu>
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb'
import { ListMessages } from '@/api/message'
import { ViewUser } from '@/api/user'

export default {
  name: 'back-header',
  data: function () {
    return {
      user: '',
      showNavicon: false,
      shrink: this.$store.getters.getShrink,
      isAuthed: this.$store.getters.auths.indexOf('系统设置') >= 0
    }
  },
  components: {
    'breadcrumb': Breadcrumb
  },
  created: function () {
    console.log(this.$store.getters.auths.indexOf('系统设置'))
    this.fetchData()
  },
  methods: {
    onSelect: function (name) {
      if (name === 'logout') {
        this.logout()
      } else {
        this.$router.push({ name: name })
      }
    },
    fetchData: function () {
      ViewUser().then(async res => {
        this.user = res
        this.$store.dispatch('changePortraitLink', this.user.portrait_link)
      })
      ListMessages({ 'status': 'new' }).then(async res => {
        let totalCount = res._meta ? res._meta.totalCount : 0
        this.$store.dispatch('getNewMessageNum', totalCount)
      })
    },
    logout: function () {
      this.$store.commit('deleteToken')
      this.$store.commit('refresh')
      this.$router.push('/')
    },
    toggleClick: function () {
      this.shrink = !this.shrink
      this.$store.dispatch('changeShrink', this.shrink)
    }
  }
}
</script>

<style>
.header-logo img{
    height: 36px;
    float: left;
    position: relative;
    top: 12px;
    left: 20px;
}
.header-logo > span {
  padding-left: 20px;
  font-weight: bold;
  font-style: italic;
}
.header-middle-con {
  padding-left: 100px;
}
</style>
